module.exports = __webpack_public_path__ + "static/img/lymphomap-luanch-thumb.0ece2a4f.jpg";